// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-message[data-v-2b11573e] {\n  font-size: 16px;\n  font-weight: bold;\n  white-space: pre-line;\n}\n.alert-footer[data-v-2b11573e] {\n  margin-top: 50px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n}\n", ""]);
// Exports
module.exports = exports;
